import React from 'react';
import styles from './PerishableFields.module.scss';

const PerishableFields = ({ formData, errors, updateFormData, clearError }) => {
  const storageTypes = [
    { value: "dry", label: "Dry" },
    { value: "frozen", label: "Frozen" }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    updateFormData(name, value);
    clearError(name); // Clear error on change
  };

  const handleSelectFocus = (fieldName) => {
    clearError(fieldName); // Clear error on focus/click
  };

  if (formData.productType !== 'perishable') {
    return null;
  }

  return (
    <>
      <div className={`${styles.label_input} ${errors.storage_type ? styles.error : ''}`}>
        <label>Storage Type<span>*</span></label>
        <div className={styles.input_container}>
          <select
            name="storage_type"
            value={formData.storage_type}
            onChange={handleInputChange}
            onFocus={() => handleSelectFocus('storage_type')}
            className={styles.select_field}
          >
            <option value="" hidden>Select Storage Type</option>
            {storageTypes.map(type => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
          {errors.storage_type && <span className={styles.errorMessage}>{errors.storage_type}</span>}
        </div>
      </div>

      <div className={`${styles.label_input} ${errors.expire_date ? styles.error : ''}`}>
        <label>Expiry Date<span>*</span></label>
        <div className={styles.input_container}>
          <input
            type="date"
            name="expire_date"
            value={formData.expire_date}
            onChange={handleInputChange}
            onFocus={() => handleSelectFocus('expire_date')}
            min={new Date().toISOString().split('T')[0]}
          />
          {errors.expire_date && <span className={styles.errorMessage}>{errors.expire_date}</span>}
        </div>
      </div>
    </>
  );
};

export default PerishableFields;